/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EmailTransactionFromJSON, EmailTransactionToJSON } from './EmailTransaction';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetContactsEmailTransactionsSendErrorsResponseDataFromJSON(json) {
    return GetContactsEmailTransactionsSendErrorsResponseDataFromJSONTyped(json, false);
}
export function GetContactsEmailTransactionsSendErrorsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        emailTransactions: !exists(json, 'email_transactions')
            ? undefined
            : json['email_transactions'].map(EmailTransactionFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetContactsEmailTransactionsSendErrorsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        email_transactions: value.emailTransactions === undefined
            ? undefined
            : value.emailTransactions.map(EmailTransactionToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
